


<template>
	<div>
		<!-- BEGIN page-header -->
		<h1 class="page-header">Конкурсы <small></small></h1>
		<!-- END page-header -->

		<!-- BEGIN row -->
		<div class="row">
			<!-- BEGIN col-6 -->
			<div class="col-xl-12">
				<!-- BEGIN nav-tabs -->


				<div class="card border-0 mb-3" v-for="(contest, index)  in contests" :key="index">
					<div class="card-body">
						<h4 class="card-title">{{ contest.title }}</h4>
						<h6 class="card-subtitle mb-10px text-muted"></h6>
						<p class="card-text">{{ contest.description }}</p>
						<p>Начат: {{ contest.started_at }}</p>
						<p>Закончится: {{ contest.completed_at }}</p>
						<table class="table table-hover">
							<thead>
								<tr>
									<th>
										<h5></h5>
									</th>
									<th>
										<h5>Пользователь</h5>
									</th>
									<th>
										<h5>Потратил </h5>
									</th>
									<th>
										<h5>Приз </h5>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(user, index) in contest.users" v-bind:key="user.id">
									<td style="width:30px;vertical-align: middle;">
										{{ index + 1 }}
									</td>
									<td style="width:200px;vertical-align: middle;">
										<img style="border-radius: 40px;" class="me-2"
											:src="`/images/avatar/` + user.avatar" alt="" width="40" height="40" />
										{{ user.name.substring(0, 12) }}
									</td>
									<td style="vertical-align: middle;">
										{{ user.balance }}<span> руб.</span>
									</td>
									<td style="width:100px;vertical-align: middle;">
										{{ user.prize }} <span v-if="user.prize"> руб.</span>
									</td>
								</tr>
								<tr v-if="!contest.users.length">
									<td colspan="4" align="center"> Нет данных </td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>


				<!-- END hljs-wrapper -->
			</div>
			<!-- END col-6 -->

		</div>
		<!-- END row -->


	</div>

</template>


<script>
	import HTTP from "../http";
	import { show_error } from "../message";

	export default {

		data() {
			return {
				loading: false,
				errors: null,
				contests: []
			};
		},

		created() {
			this.fetchData()
		},

		methods: {

			fetchData() {
				this.loading = true;
				this.$insProgress.start();

				HTTP()
					.get(`/contests?adv`)
					.then((resp) => {
						console.log('resp', resp)
						this.contests = resp.data;
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			},

		}
	}

</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}
</style>

